// AUTO-GENERATED from content/loot/ — do not edit by hand

export interface DropEntry {
  itemId: string;
  dropRate: number;
}

export interface MonsterDropTable {
  common?: DropEntry[];
  uncommon?: DropEntry[];
  rare?: DropEntry[];
}

export interface GoldDropConfig {
  chance: number;
  min: number;
  max: number;
}

export const MONSTER_DROPS: Record<string, MonsterDropTable> = {
  'pig': {
    common: [{ itemId: 'pig_foot', dropRate: 0.4 }, { itemId: 'pig_snout', dropRate: 0.5 }],
    uncommon: [{ itemId: 'cloth_gloves', dropRate: 0.04 }],
  },
  'slime': {
    common: [{ itemId: 'slime_gel', dropRate: 0.45 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.08 }, { itemId: 'copper_ring', dropRate: 0.05 }],
  },
  'slimeling': {
    common: [{ itemId: 'slime_gel', dropRate: 0.45 }],
  },
  'snail': {
    common: [{ itemId: 'snail_shell', dropRate: 0.5 }, { itemId: 'slime_gel', dropRate: 0.25 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.1 }, { itemId: 'apprentice_hat', dropRate: 0.05 }],
  },
  'mushroom': {
    common: [{ itemId: 'mushroom_spore', dropRate: 0.5 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.1 }, { itemId: 'leather_leggings', dropRate: 0.06 }],
  },
  'test_pig': {
    common: [{ itemId: 'pig_foot', dropRate: 1 }],
  },
  'stump': {
    common: [{ itemId: 'dark_wood', dropRate: 0.4 }, { itemId: 'mushroom_spore', dropRate: 0.35 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.12 }, { itemId: 'training_sword', dropRate: 0.05 }],
  },
  'evil_eye': {
    common: [{ itemId: 'slime_gel', dropRate: 0.3 }, { itemId: 'eye_shard', dropRate: 0.3 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.1 }, { itemId: 'iron_helm', dropRate: 0.06 }],
  },
  'fire_boar': {
    common: [{ itemId: 'pig_foot', dropRate: 0.5 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.12 }],
  },
  'moonfall_stone_golem': {
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.35 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.12 }],
  },
  'stone_golem': {
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.15 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.05 }],
  },
  'ice_drake': {
    common: [{ itemId: 'drake_scale', dropRate: 0.4 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.15 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.05 }],
  },
  'dark_stump': {
    common: [{ itemId: 'dark_wood', dropRate: 0.45 }],
    uncommon: [{ itemId: 'mushroom_spore', dropRate: 0.25 }, { itemId: 'iron_chainmail', dropRate: 0.08 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.04 }],
  },
  'blightroot_alpha': {
    common: [{ itemId: 'dark_wood', dropRate: 0.8 }, { itemId: 'dark_essence', dropRate: 0.5 }],
    uncommon: [{ itemId: 'iron_chainmail', dropRate: 0.15 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.1 }],
  },
  'elite_slime': {
    common: [{ itemId: 'slime_gel', dropRate: 0.8 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.3 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.1 }],
  },
  'shadow_bat': {
    common: [{ itemId: 'mushroom_spore', dropRate: 0.3 }, { itemId: 'bat_wing', dropRate: 0.35 }],
    rare: [{ itemId: 'gloamwisp_lantern', dropRate: 0.03 }],
  },
  'cursed_armor': {
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.2 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.08 }],
  },
  'hollow_keeper': {
    common: [{ itemId: 'hollow_essence', dropRate: 1 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 1 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.5 }, { itemId: 'shadow_leather', dropRate: 0.15 }, { itemId: 'holy_plate', dropRate: 0.15 }, { itemId: 'hunters_mail', dropRate: 0.15 }, { itemId: 'volcanic_plate', dropRate: 0.2 }, { itemId: 'volcanic_helm', dropRate: 0.2 }, { itemId: 'frostweave_robe', dropRate: 0.2 }, { itemId: 'frostweave_hat', dropRate: 0.2 }],
  },
  'crystal_spider': {
    common: [{ itemId: 'slime_gel', dropRate: 0.35 }],
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.12 }],
  },
  'gem_golem': {
    uncommon: [{ itemId: 'stone_fragment', dropRate: 0.3 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.1 }],
  },
  'void_wraith': {
    common: [{ itemId: 'dark_essence', dropRate: 0.6 }],
    uncommon: [{ itemId: 'cursed_plate', dropRate: 0.2 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.15 }, { itemId: 'void_fragment', dropRate: 0.08 }],
  },
  'cave_bat': {
    common: [{ itemId: 'mushroom_spore', dropRate: 0.3 }],
  },
  'frost_elemental': {
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.25 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.08 }, { itemId: 'frost_shard', dropRate: 0.12 }],
  },
  'snow_wolf': {
    common: [{ itemId: 'pig_foot', dropRate: 0.3 }],
  },
  'lava_slug': {
    common: [{ itemId: 'stone_fragment', dropRate: 0.4 }],
    uncommon: [{ itemId: 'dark_essence', dropRate: 0.15 }],
  },
  'magma_golem': {
    uncommon: [{ itemId: 'stone_fragment', dropRate: 0.35 }],
    rare: [{ itemId: 'cursed_plate', dropRate: 0.1 }],
  },
  'infernal': {
    common: [{ itemId: 'dark_essence', dropRate: 0.8 }],
    uncommon: [{ itemId: 'cursed_plate', dropRate: 0.4 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.3 }, { itemId: 'infernal_greatsword', dropRate: 0.05 }, { itemId: 'ring_of_power', dropRate: 0.08 }],
  },
  'giant_bee': {
    common: [{ itemId: 'mushroom_spore', dropRate: 0.35 }, { itemId: 'bee_stinger', dropRate: 0.4 }],
    uncommon: [{ itemId: 'traveler_gloves', dropRate: 0.06 }],
  },
  'forest_troll': {
    common: [{ itemId: 'pig_foot', dropRate: 0.3 }, { itemId: 'dark_essence', dropRate: 0.4 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.12 }],
  },
  'flame_imp': {
    common: [{ itemId: 'dark_essence', dropRate: 0.35 }],
    uncommon: [{ itemId: 'stone_fragment', dropRate: 0.15 }],
  },
  'obsidian_sentinel': {
    uncommon: [{ itemId: 'cursed_plate', dropRate: 0.2 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.1 }],
  },
  'phoenix': {
    common: [{ itemId: 'dark_essence', dropRate: 0.7 }],
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.3 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.2 }, { itemId: 'ring_of_power', dropRate: 0.05 }, { itemId: 'phoenix_feather', dropRate: 0.1 }, { itemId: 'fire_crystal', dropRate: 0.15 }],
  },
  'jellyfish': {
    common: [{ itemId: 'slime_gel', dropRate: 0.25 }],
  },
  'wild_boar': {
    common: [{ itemId: 'pig_foot', dropRate: 0.4 }, { itemId: 'boar_tusk', dropRate: 0.4 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.1 }, { itemId: 'leather_vest', dropRate: 0.07 }],
  },
  'crystal_elemental': {
    common: [{ itemId: 'stone_fragment', dropRate: 0.4 }],
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.15 }],
  },
  'shadow_stalker': {
    common: [{ itemId: 'dark_essence', dropRate: 0.35 }],
    uncommon: [{ itemId: 'cursed_plate', dropRate: 0.1 }],
  },
  'ancient_treant': {
    uncommon: [{ itemId: 'mushroom_spore', dropRate: 0.3 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.08 }],
  },
  'war_golem': {
    uncommon: [{ itemId: 'stone_fragment', dropRate: 0.3 }],
    rare: [{ itemId: 'cursed_plate', dropRate: 0.12 }],
  },
  'void_walker': {
    common: [{ itemId: 'dark_essence', dropRate: 0.5 }],
    uncommon: [{ itemId: 'cursed_plate', dropRate: 0.15 }],
  },
  'crystal_king': {
    common: [{ itemId: 'gold_ore', dropRate: 0.6 }],
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.5 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.3 }, { itemId: 'frost_shard', dropRate: 0.25 }, { itemId: 'crystal_blade', dropRate: 0.12 }, { itemId: 'crystal_bow', dropRate: 0.12 }, { itemId: 'crystal_helm', dropRate: 0.12 }, { itemId: 'hunter_legs', dropRate: 0.1 }],
  },
  'leviathan': {
    common: [{ itemId: 'reagent_shiny_fish_scales', dropRate: 0.9 }],
    uncommon: [{ itemId: 'power_elixir', dropRate: 0.4 }, { itemId: 'beach_trinket', dropRate: 0.3 }],
    rare: [{ itemId: 'pendant_of_wisdom', dropRate: 0.25 }, { itemId: 'amulet_of_the_bear', dropRate: 0.25 }],
  },
  'arch_lich_malakar': {
    common: [{ itemId: 'dark_essence', dropRate: 1 }],
    uncommon: [{ itemId: 'cursed_plate', dropRate: 0.6 }, { itemId: 'void_fragment', dropRate: 0.4 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.5 }, { itemId: 'ring_of_power', dropRate: 0.15 }, { itemId: 'mage_cloth_chest', dropRate: 0.25 }, { itemId: 'icemage_gloves', dropRate: 0.1 }],
  },
  'young_fire_drake': {
    common: [{ itemId: 'fire_essence', dropRate: 0.35 }],
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.15 }, { itemId: 'fire_protection_potion', dropRate: 0.06 }],
    rare: [{ itemId: 'essence_of_fire', dropRate: 0.07 }, { itemId: 'inferno_core', dropRate: 0.05 }],
  },
  'wolf': {
    common: [{ itemId: 'wolf_meat', dropRate: 0.45 }],
    uncommon: [{ itemId: 'light_leather', dropRate: 0.15 }],
    rare: [{ itemId: 'medium_leather', dropRate: 0.04 }],
  },
  'grimfang_the_ravenous': {
    common: [{ itemId: 'rugged_leather', dropRate: 0.4 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.2 }],
    rare: [{ itemId: 'shadow_daggers', dropRate: 0.3 }, { itemId: 'hunter_head', dropRate: 0.2 }],
  },
  'darkwood_bear_elite': {
    common: [{ itemId: 'food_smoked_bear_meat', dropRate: 0.4 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.14 }],
    rare: [{ itemId: 'amulet_of_the_bear', dropRate: 0.12 }, { itemId: 'icemage_boots', dropRate: 0.1 }],
  },
  'venomous_spider_elite': {
    common: [{ itemId: 'reagent_spider_ichor', dropRate: 0.4 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.17 }],
    rare: [{ itemId: 'crossbow_of_precision', dropRate: 0.2 }, { itemId: 'icemage_chest', dropRate: 0.2 }],
  },
  'forest_spider': {
    common: [{ itemId: 'reagent_spider_ichor', dropRate: 0.25 }],
    rare: [{ itemId: 'warrior_plate_chest', dropRate: 0.02 }],
  },
  'rabid_wolf': {
    common: [{ itemId: 'wolf_meat', dropRate: 0.35 }],
    uncommon: [{ itemId: 'light_leather', dropRate: 0.15 }],
    rare: [{ itemId: 'medium_leather', dropRate: 0.06 }],
  },
  'brigand_cutpurse': {
    common: [{ itemId: 'linen_cloth', dropRate: 0.3 }, { itemId: 'cloth_pants', dropRate: 0.06 }, { itemId: 'staff', dropRate: 0.06 }, { itemId: 'leather_gloves', dropRate: 0.06 }, { itemId: 'iron_battleaxe', dropRate: 0.06 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.1 }],
    rare: [{ itemId: 'dagger', dropRate: 0.04 }],
  },
  'brigand_footpad': {
    common: [{ itemId: 'linen_cloth', dropRate: 0.3 }, { itemId: 'cloth_shirt', dropRate: 0.06 }, { itemId: 'sword', dropRate: 0.06 }, { itemId: 'iron_boots', dropRate: 0.06 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.11 }, { itemId: 'gnoll_chieftain_belt', dropRate: 0.04 }],
    rare: [{ itemId: 'brigand_leather_gloves', dropRate: 0.05 }],
  },
  'darkwood_treant': {
    common: [{ itemId: 'silverleaf', dropRate: 0.25 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.11 }],
    rare: [{ itemId: 'scroll_large_tree', dropRate: 0.04 }],
  },
  'corrupted_dryad': {
    common: [{ itemId: 'calmbloom_herb', dropRate: 0.25 }],
    uncommon: [{ itemId: 'sungold_root', dropRate: 0.1 }],
    rare: [{ itemId: 'hunter_feet', dropRate: 0.03 }],
  },
  'giant_stag_beetle': {
    common: [{ itemId: 'rough_stone', dropRate: 0.25 }],
    rare: [{ itemId: 'trinket_warriors_badge', dropRate: 0.02 }],
  },
  'moss_lurker': {
    common: [{ itemId: 'silverleaf', dropRate: 0.25 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.12 }],
    rare: [{ itemId: 'warrior_plate_hands', dropRate: 0.02 }],
  },
  'bandit_leader_grix': {
    common: [{ itemId: 'wool_cloth', dropRate: 0.3 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.12 }],
    rare: [{ itemId: 'shadow_dagger', dropRate: 0.1 }, { itemId: 'blood_dagger_epic', dropRate: 0.1 }, { itemId: 'rogue_chest', dropRate: 0.1 }],
  },
  'elder_treant': {
    common: [{ itemId: 'sungold_root', dropRate: 0.25 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.13 }],
    rare: [{ itemId: 'ring_of_fortitude', dropRate: 0.2 }, { itemId: 'scroll_large_tree', dropRate: 0.2 }, { itemId: 'hunter_hands', dropRate: 0.2 }],
  },
  'mountain_goat': {
    common: [{ itemId: 'wool_cloth', dropRate: 0.3 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.13 }],
    rare: [{ itemId: 'rugged_leather', dropRate: 0.1 }],
  },
  'rock_elemental': {
    common: [{ itemId: 'rough_stone', dropRate: 0.35 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.14 }],
    rare: [{ itemId: 'essence_of_earth', dropRate: 0.07 }],
  },
  'harpy_windcaller': {
    common: [{ itemId: 'light_feather', dropRate: 0.35 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.15 }],
    rare: [{ itemId: 'dark_essence', dropRate: 0.07 }],
  },
  'mountain_troll': {
    common: [{ itemId: 'tundra_leather', dropRate: 0.3 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.15 }, { itemId: 'enchanted_gold_ring', dropRate: 0.04 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.07 }],
  },
  'ice_wraith': {
    common: [{ itemId: 'frost_shard', dropRate: 0.35 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.15 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.06 }, { itemId: 'frozen_orb', dropRate: 0.05 }, { itemId: 'druid_leather_legs', dropRate: 0.02 }],
  },
  'stone_drake': {
    common: [{ itemId: 'stone_fragment', dropRate: 0.35 }, { itemId: 'dragon_fang', dropRate: 0.15 }],
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.1 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.08 }],
  },
  'cave_bear': {
    common: [{ itemId: 'food_smoked_bear_meat', dropRate: 0.3 }],
    uncommon: [{ itemId: 'wolf_pelt', dropRate: 0.15 }, { itemId: 'plate_leggings', dropRate: 0.04 }],
    rare: [{ itemId: 'spiced_bear_stew', dropRate: 0.05 }],
  },
  'harpy_matriarch': {
    common: [{ itemId: 'light_feather', dropRate: 0.4 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.17 }],
    rare: [{ itemId: 'phoenix_feather', dropRate: 0.1 }, { itemId: 'unbinding_draught', dropRate: 0.16 }, { itemId: 'hunter_mainhand', dropRate: 0.2 }],
  },
  'avalanche_golem': {
    common: [{ itemId: 'frost_shard', dropRate: 0.4 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.18 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.18 }, { itemId: 'tower_shield', dropRate: 0.16 }, { itemId: 'icemage_head', dropRate: 0.2 }],
  },
  'skeletal_warrior': {
    common: [{ itemId: 'soul_dust', dropRate: 0.35 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.18 }, { itemId: 'plate_chestpiece', dropRate: 0.04 }],
    rare: [{ itemId: 'warrior_plate_feet', dropRate: 0.05 }],
  },
  'skeletal_mage': {
    common: [{ itemId: 'vision_dust', dropRate: 0.35 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.18 }],
    rare: [{ itemId: 'mage_cloth_hands', dropRate: 0.05 }, { itemId: 'potion_major_healing', dropRate: 0.04 }, { itemId: 'pendant_of_wisdom', dropRate: 0.02 }],
  },
  'tomb_scarab': {
    common: [{ itemId: 'reagent_ichor', dropRate: 0.3 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.18 }, { itemId: 'silk_headband', dropRate: 0.04 }],
    rare: [{ itemId: 'trinket_warriors_badge', dropRate: 0.05 }, { itemId: 'druid_leather_helm', dropRate: 0.02 }],
  },
  'cursed_archaeologist': {
    common: [{ itemId: 'vial_empty', dropRate: 0.35 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.19 }],
    rare: [{ itemId: 'gravecleaver', dropRate: 0.25 }, { itemId: 'bardiche_rare', dropRate: 0.2 }, { itemId: 'rogue_boots', dropRate: 0.2 }],
  },
  'kobold_miner': {
    common: [{ itemId: 'iron_ore', dropRate: 0.3 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.13 }],
    rare: [{ itemId: 'gold_ore', dropRate: 0.08 }],
  },
  'kobold_shaman': {
    common: [{ itemId: 'crystal_vial', dropRate: 0.3 }],
    uncommon: [{ itemId: 'minor_mana_potion', dropRate: 0.14 }],
    rare: [{ itemId: 'mystic_wand', dropRate: 0.06 }, { itemId: 'enchanted_sword_mage', dropRate: 0.04 }],
  },
  'plague_rat': {
    common: [{ itemId: 'strange_dust', dropRate: 0.25 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.11 }],
    rare: [{ itemId: 'mage_cloth_legs', dropRate: 0.02 }],
  },
  'dire_wolf': {
    common: [{ itemId: 'medium_leather', dropRate: 0.3 }],
    uncommon: [{ itemId: 'wolf_meat', dropRate: 0.3 }],
    rare: [{ itemId: 'hunter_head', dropRate: 0.02 }],
  },
  'owlbear': {
    common: [{ itemId: 'reagent_light_feather', dropRate: 0.35 }],
    uncommon: [{ itemId: 'food_smoked_bear_meat', dropRate: 0.15 }],
    rare: [{ itemId: 'returning_boomerang', dropRate: 0.05 }, { itemId: 'warrior_plate_helm', dropRate: 0.02 }],
  },
  'basilisk': {
    common: [{ itemId: 'stone_fragment', dropRate: 0.35 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.19 }],
    rare: [{ itemId: 'cursed_plate', dropRate: 0.1 }],
  },
  'kobold_worker': {
    common: [{ itemId: 'copper_ore', dropRate: 0.25 }],
    rare: [{ itemId: 'gold_ore', dropRate: 0.03 }],
  },
  'kobold_tunneler': {
    common: [{ itemId: 'rough_stone', dropRate: 0.25 }],
    rare: [{ itemId: 'gold_ore', dropRate: 0.04 }],
  },
  'brigand_thug': {
    common: [{ itemId: 'wool_cloth', dropRate: 0.3 }, { itemId: 'mace', dropRate: 0.06 }, { itemId: 'oak_quarterstaff', dropRate: 0.06 }, { itemId: 'tough_leather_vest', dropRate: 0.06 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.12 }, { itemId: 'frost_wand', dropRate: 0.04 }],
    rare: [{ itemId: 'rogue_gloves', dropRate: 0.03 }],
  },
  'duchess': {
    common: [{ itemId: 'food_rye_bread', dropRate: 0.4 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.13 }],
    rare: [{ itemId: 'trinket_lucky_coin', dropRate: 0.25 }, { itemId: 'experience_scroll', dropRate: 0.1 }, { itemId: 'hunter_feet', dropRate: 0.1 }],
  },
  'rimecrest_troll': {
    common: [{ itemId: 'frost_shard', dropRate: 0.3 }],
    uncommon: [{ itemId: 'tundra_leather', dropRate: 0.12 }],
    rare: [{ itemId: 'priest_cloth_chest', dropRate: 0.02 }],
  },
  'wendigo': {
    common: [{ itemId: 'tundra_leather', dropRate: 0.3 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.14 }],
    rare: [{ itemId: 'priest_cloth_helm', dropRate: 0.02 }],
  },
  'mindless_zombie': {
    common: [{ itemId: 'linen_cloth', dropRate: 0.3 }],
    uncommon: [{ itemId: 'soul_dust', dropRate: 0.12 }],
    rare: [{ itemId: 'mage_cloth_helm', dropRate: 0.02 }],
  },
  'ember_vigil_zealot': {
    common: [{ itemId: 'silk_cloth', dropRate: 0.3 }],
    uncommon: [{ itemId: 'silk_bandage', dropRate: 0.15 }],
    rare: [{ itemId: 'warrior_t1_boots', dropRate: 0.04 }, { itemId: 'holy_mace', dropRate: 0.04 }, { itemId: 'mage_cloth_feet', dropRate: 0.02 }],
  },
  'sandstinger': {
    common: [{ itemId: 'sandstinger_scale', dropRate: 0.35 }],
    uncommon: [{ itemId: 'sandswarm_carapace', dropRate: 0.15 }],
    rare: [{ itemId: 'cursed_plate', dropRate: 0.03 }],
  },
  'voodoo_troll': {
    common: [{ itemId: 'frost_shard', dropRate: 0.3 }],
    uncommon: [{ itemId: 'blue_potion', dropRate: 0.14 }],
    rare: [{ itemId: 'priest_cloth_hands', dropRate: 0.02 }],
  },
  'brigand_raider': {
    common: [{ itemId: 'wool_cloth', dropRate: 0.35 }, { itemId: 'wooden_buckler', dropRate: 0.06 }, { itemId: 'iron_mace', dropRate: 0.06 }, { itemId: 'iron_longsword', dropRate: 0.06 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.14 }, { itemId: 'conscripts_shortsword', dropRate: 0.04 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.07 }],
  },
  'scarecrow_golem': {
    common: [{ itemId: 'food_hearthside_pie', dropRate: 0.25 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.15 }],
    rare: [{ itemId: 'leather_helm', dropRate: 0.06 }],
  },
  'stripe_runner': {
    common: [{ itemId: 'light_leather', dropRate: 0.35 }, { itemId: 'apprentice_robe', dropRate: 0.06 }, { itemId: 'wooden_shield', dropRate: 0.06 }, { itemId: 'buckler_shield', dropRate: 0.06 }],
    uncommon: [{ itemId: 'medium_leather', dropRate: 0.14 }, { itemId: 'recruit_linen_vest', dropRate: 0.04 }, { itemId: 'archer_tunic', dropRate: 0.04 }],
    rare: [{ itemId: 'orange_potion', dropRate: 0.06 }],
  },
  'centaur_scout': {
    common: [{ itemId: 'reagent_light_feather', dropRate: 0.3 }],
    uncommon: [{ itemId: 'composite_bow_rare', dropRate: 0.04 }, { itemId: 'major_mana_potion', dropRate: 0.05 }],
    rare: [{ itemId: 'leather_whip', dropRate: 0.05 }, { itemId: 'druid_leather_chest', dropRate: 0.02 }, { itemId: 'priest_cloth_legs', dropRate: 0.02 }],
  },
  'thornpaw_pathfinder': {
    common: [{ itemId: 'wolf_pelt', dropRate: 0.3 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.17 }],
    rare: [{ itemId: 'rugged_leather_pants', dropRate: 0.05 }, { itemId: 'warrior_plate_legs', dropRate: 0.02 }],
  },
  'amberbark_treant': {
    common: [{ itemId: 'silverleaf', dropRate: 0.3 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.18 }],
    rare: [{ itemId: 'essence_of_earth', dropRate: 0.06 }],
  },
  'naga_siren': {
    common: [{ itemId: 'reagent_naga_mucus', dropRate: 0.3 }],
    uncommon: [{ itemId: 'greater_mana_potion', dropRate: 0.15 }, { itemId: 'major_healing_potion', dropRate: 0.05 }],
    rare: [{ itemId: 'arcane_crown', dropRate: 0.04 }, { itemId: 'druid_leather_hands', dropRate: 0.02 }, { itemId: 'shadow_cloak', dropRate: 0.02 }],
  },
  'brigand_smuggler': {
    common: [{ itemId: 'wool_cloth', dropRate: 0.35 }, { itemId: 'worn_shortsword', dropRate: 0.06 }, { itemId: 'iron_tomahawk', dropRate: 0.06 }, { itemId: 'steel_dagger', dropRate: 0.06 }],
    uncommon: [{ itemId: 'silk_cloth', dropRate: 0.15 }, { itemId: 'fire_wand', dropRate: 0.04 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.07 }],
  },
  'brigand_lieutenant': {
    common: [{ itemId: 'silk_cloth', dropRate: 0.3 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.17 }],
    rare: [{ itemId: 'moorwatch_chausses', dropRate: 0.05 }, { itemId: 'crimson_fang_epic', dropRate: 0.1 }, { itemId: 'rogue_gloves', dropRate: 0.1 }],
  },
  'deepglow_ooze': {
    common: [{ itemId: 'reagent_ichor', dropRate: 0.35 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.16 }],
    rare: [{ itemId: 'void_crystal', dropRate: 0.05 }, { itemId: 'void_robe', dropRate: 0.03 }, { itemId: 'void_staff', dropRate: 0.03 }],
  },
  'rabbit': {
    common: [{ itemId: 'light_leather', dropRate: 0.25 }],
    rare: [{ itemId: 'medium_leather', dropRate: 0.03 }],
  },
  'rat': {
    common: [{ itemId: 'strange_dust', dropRate: 0.2 }],
    rare: [{ itemId: 'mage_cloth_legs', dropRate: 0.01 }],
  },
  'deer': {
    common: [{ itemId: 'light_leather', dropRate: 0.25 }],
    rare: [{ itemId: 'medium_leather', dropRate: 0.05 }],
  },
  'captain_morrow_vane': {
    common: [{ itemId: 'silk_cloth', dropRate: 0.35 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.18 }],
    rare: [{ itemId: 'moorwatch_chausses', dropRate: 0.12 }, { itemId: 'hunter_chest', dropRate: 0.1 }, { itemId: 'rogue_head', dropRate: 0.1 }],
  },
  'gilling_coastrunner': {
    common: [{ itemId: 'fresh_fish', dropRate: 0.3 }],
    uncommon: [{ itemId: 'reagent_shiny_fish_scales', dropRate: 0.15 }, { itemId: 'orange_potion', dropRate: 0.11 }],
    rare: [{ itemId: 'beach_trinket', dropRate: 0.05 }],
  },
  'gilling_bogchief': {
    common: [{ itemId: 'reagent_shiny_fish_scales', dropRate: 0.6 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.4 }, { itemId: 'beach_trinket', dropRate: 0.25 }],
    rare: [{ itemId: 'tribal_spear', dropRate: 0.25 }, { itemId: 'mail_helm', dropRate: 0.25 }],
  },
  'scarecrow_warden': {
    common: [{ itemId: 'food_hearthside_pie', dropRate: 0.3 }],
    uncommon: [{ itemId: 'red_potion', dropRate: 0.16 }],
    rare: [{ itemId: 'thick_bronze_necklace', dropRate: 0.06 }],
  },
  'moonhowler_lurker': {
    common: [{ itemId: 'rugged_leather', dropRate: 0.3 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.15 }],
    rare: [{ itemId: 'power_elixir', dropRate: 0.05 }, { itemId: 'invisibility_potion', dropRate: 0.04 }],
  },
  'clodkin_stonecutter': {
    common: [{ itemId: 'rough_grinding_stone', dropRate: 0.25 }],
    rare: [{ itemId: 'void_crystal', dropRate: 0.03 }],
  },
  'tuskmire_raider': {
    common: [{ itemId: 'boar_tusk', dropRate: 0.25 }, { itemId: 'bow', dropRate: 0.06 }, { itemId: 'simple_wand', dropRate: 0.06 }, { itemId: 'axe', dropRate: 0.06 }, { itemId: 'hunting_shortbow', dropRate: 0.06 }, { itemId: 'iron_spear', dropRate: 0.06 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.13 }],
    rare: [{ itemId: 'scouts_leather_spaulders', dropRate: 0.05 }],
  },
  'tuskmire_warchief': {
    common: [{ itemId: 'boar_tusk', dropRate: 0.6 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.4 }],
    rare: [{ itemId: 'tough_leather_vest', dropRate: 0.25 }, { itemId: 'bronze_helm', dropRate: 0.25 }],
  },
  'gearwright_logger': {
    common: [{ itemId: 'food_rye_bread', dropRate: 0.3 }],
    uncommon: [{ itemId: 'linen_bandage', dropRate: 0.15 }],
    rare: [{ itemId: 'chain_mail_vest', dropRate: 0.04 }],
  },
  'longleg_strider': {
    common: [{ itemId: 'light_feather', dropRate: 0.5 }, { itemId: 'hide_boots', dropRate: 0.06 }, { itemId: 'wand', dropRate: 0.06 }],
    uncommon: [{ itemId: 'adepts_wand', dropRate: 0.04 }, { itemId: 'scouts_leather_spaulders', dropRate: 0.04 }, { itemId: 'bronze_helm', dropRate: 0.04 }],
    rare: [{ itemId: 'tough_leather_vest', dropRate: 0.03 }],
  },
  'canopy_weaver': {
    common: [{ itemId: 'spider_silk_thread', dropRate: 0.6 }],
    uncommon: [{ itemId: 'plate_helm', dropRate: 0.04 }],
    rare: [{ itemId: 'warrior_plate_chest', dropRate: 0.02 }],
  },
  'murkwater_snapjaw': {
    common: [{ itemId: 'thick_leather', dropRate: 0.35 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.19 }],
    rare: [{ itemId: 'cursed_plate', dropRate: 0.1 }],
  },
  'stormbreak_wyvern': {
    common: [{ itemId: 'light_feather', dropRate: 0.35 }, { itemId: 'dragon_scale', dropRate: 0.15 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.17 }, { itemId: 'pristine_dragon_scale', dropRate: 0.05 }],
    rare: [{ itemId: 'drake_scale', dropRate: 0.08 }],
  },
  'tuskmire_grunda': {
    common: [{ itemId: 'boar_tusk', dropRate: 0.6 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.3 }],
    rare: [{ itemId: 'grundas_gilded_tusk', dropRate: 1 }, { itemId: 'scouts_leather_spaulders', dropRate: 0.2 }],
  },
  'gilling_glimmergill': {
    common: [{ itemId: 'reagent_shiny_fish_scales', dropRate: 0.6 }],
    uncommon: [{ itemId: 'beach_trinket', dropRate: 0.5 }, { itemId: 'orange_potion', dropRate: 0.3 }],
    rare: [{ itemId: 'glimmergills_lucky_shard', dropRate: 1 }],
  },
  'sandstinger_sunback': {
    common: [{ itemId: 'sandstinger_scale', dropRate: 0.6 }],
    uncommon: [{ itemId: 'sandswarm_carapace', dropRate: 0.4 }],
    rare: [{ itemId: 'sunbacks_bleached_carapace', dropRate: 1 }],
  },
  'stormbreak_galeclaw': {
    common: [{ itemId: 'light_feather', dropRate: 0.6 }],
    uncommon: [{ itemId: 'pristine_dragon_scale', dropRate: 0.2 }, { itemId: 'orange_potion', dropRate: 0.3 }],
    rare: [{ itemId: 'galeclaws_storm_feather', dropRate: 1 }, { itemId: 'drake_scale', dropRate: 0.25 }],
  },
  'rimecrest_brakka': {
    common: [{ itemId: 'frost_shard', dropRate: 0.6 }],
    uncommon: [{ itemId: 'tundra_leather', dropRate: 0.35 }],
    rare: [{ itemId: 'brakkas_rime_tusk', dropRate: 1 }, { itemId: 'priest_cloth_chest', dropRate: 0.1 }],
  },
  'moonhowler_tobin': {
    common: [{ itemId: 'rugged_leather', dropRate: 0.6 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.3 }],
    rare: [{ itemId: 'tobins_silvered_claw', dropRate: 1 }, { itemId: 'power_elixir', dropRate: 0.2 }],
  },
  'ember_vigil_aldous': {
    common: [{ itemId: 'silk_cloth', dropRate: 0.6 }],
    uncommon: [{ itemId: 'silk_bandage', dropRate: 0.35 }],
    rare: [{ itemId: 'censors_vigil_badge', dropRate: 1 }, { itemId: 'holy_mace', dropRate: 0.15 }],
  },
  'thornpaw_mossclaw': {
    common: [{ itemId: 'wolf_pelt', dropRate: 0.6 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.3 }],
    rare: [{ itemId: 'mossclaws_heartwood_totem', dropRate: 1 }, { itemId: 'rugged_leather_pants', dropRate: 0.2 }],
  },
  'clodkin_chertjaw': {
    common: [{ itemId: 'rough_grinding_stone', dropRate: 0.6 }],
    uncommon: [{ itemId: 'orange_potion', dropRate: 0.3 }],
    rare: [{ itemId: 'chertjaws_seam_crystal', dropRate: 1 }],
  },
  'fire_drake_ashkettle': {
    common: [{ itemId: 'fire_essence', dropRate: 0.6 }],
    uncommon: [{ itemId: 'drake_scale', dropRate: 0.4 }, { itemId: 'fire_protection_potion', dropRate: 0.2 }],
    rare: [{ itemId: 'ashkettles_smoldering_scale', dropRate: 1 }, { itemId: 'inferno_core', dropRate: 0.15 }],
  },
  'centaur_sorrel': {
    common: [{ itemId: 'reagent_light_feather', dropRate: 0.6 }],
    uncommon: [{ itemId: 'major_mana_potion', dropRate: 0.25 }],
    rare: [{ itemId: 'sorrels_copper_spur', dropRate: 1 }, { itemId: 'leather_whip', dropRate: 0.15 }, { itemId: 'composite_bow_rare', dropRate: 0.1 }],
  },
};

export const GOLD_DROP_CONFIG: Record<string, GoldDropConfig> = {
  'pig': { chance: 0.6, min: 1, max: 3 },
  'slime': { chance: 0.5, min: 1, max: 2 },
  'slimeling': { chance: 0.6, min: 1, max: 3 },
  'snail': { chance: 0.4, min: 1, max: 1 },
  'mushroom': { chance: 0.7, min: 2, max: 5 },
  'training_dummy': { chance: 0, min: 0, max: 0 },
  'test_pig': { chance: 1, min: 3, max: 5 },
  'stump': { chance: 0.7, min: 3, max: 7 },
  'evil_eye': { chance: 0.6, min: 2, max: 5 },
  'fire_boar': { chance: 0.8, min: 5, max: 12 },
  'moonfall_stone_golem': { chance: 1, min: 15, max: 30 },
  'stone_golem': { chance: 0.9, min: 8, max: 20 },
  'ice_drake': { chance: 0.8, min: 6, max: 15 },
  'dark_stump': { chance: 0.9, min: 10, max: 25 },
  'blightroot_alpha': { chance: 1, min: 40, max: 80 },
  'elite_slime': { chance: 1, min: 20, max: 50 },
  'shadow_bat': { chance: 0.5, min: 2, max: 6 },
  'cursed_armor': { chance: 1, min: 15, max: 35 },
  'hollow_keeper': { chance: 1, min: 80, max: 140 },
  'crystal_spider': { chance: 0.8, min: 8, max: 18 },
  'gem_golem': { chance: 1, min: 20, max: 45 },
  'void_wraith': { chance: 1, min: 50, max: 100 },
  'cave_bat': { chance: 0.6, min: 5, max: 12 },
  'frost_elemental': { chance: 1, min: 15, max: 35 },
  'snow_wolf': { chance: 0.7, min: 6, max: 15 },
  'lava_slug': { chance: 0.8, min: 10, max: 25 },
  'magma_golem': { chance: 1, min: 30, max: 60 },
  'infernal': { chance: 1, min: 100, max: 250 },
  'giant_bee': { chance: 0.6, min: 3, max: 8 },
  'forest_troll': { chance: 0.8, min: 5, max: 12 },
  'flame_imp': { chance: 0.9, min: 12, max: 30 },
  'obsidian_sentinel': { chance: 1, min: 25, max: 55 },
  'phoenix': { chance: 1, min: 60, max: 150 },
  'jellyfish': { chance: 0.3, min: 1, max: 2 },
  'wild_boar': { chance: 0.7, min: 4, max: 10 },
  'crystal_elemental': { chance: 0.9, min: 10, max: 22 },
  'shadow_stalker': { chance: 0.8, min: 12, max: 28 },
  'ancient_treant': { chance: 1, min: 20, max: 45 },
  'war_golem': { chance: 1, min: 25, max: 55 },
  'void_walker': { chance: 0.9, min: 18, max: 40 },
  'crystal_king': { chance: 1, min: 80, max: 200 },
  'leviathan': { chance: 1, min: 150, max: 400 },
  'arch_lich_malakar': { chance: 1, min: 300, max: 800 },
  'young_fire_drake': { chance: 0.8, min: 23, max: 58 },
  'wolf': { chance: 0.4, min: 2, max: 5 },
  'grimfang_the_ravenous': { chance: 1, min: 99, max: 234 },
  'darkwood_bear_elite': { chance: 0.8, min: 18, max: 45 },
  'venomous_spider_elite': { chance: 1, min: 116, max: 273 },
  'forest_spider': { chance: 0.5, min: 3, max: 8 },
  'rabid_wolf': { chance: 0.5, min: 5, max: 13 },
  'brigand_cutpurse': { chance: 0.5, min: 6, max: 15 },
  'brigand_footpad': { chance: 0.6, min: 8, max: 20 },
  'darkwood_treant': { chance: 0.6, min: 9, max: 23 },
  'corrupted_dryad': { chance: 0.6, min: 11, max: 28 },
  'giant_stag_beetle': { chance: 0.5, min: 5, max: 13 },
  'moss_lurker': { chance: 0.6, min: 12, max: 30 },
  'bandit_leader_grix': { chance: 0.6, min: 12, max: 30 },
  'elder_treant': { chance: 1, min: 82, max: 195 },
  'mountain_goat': { chance: 0.7, min: 15, max: 38 },
  'rock_elemental': { chance: 0.8, min: 18, max: 45 },
  'harpy_windcaller': { chance: 0.8, min: 20, max: 50 },
  'mountain_troll': { chance: 0.8, min: 21, max: 53 },
  'ice_wraith': { chance: 0.8, min: 23, max: 58 },
  'stone_drake': { chance: 0.9, min: 24, max: 60 },
  'cave_bear': { chance: 0.8, min: 20, max: 50 },
  'harpy_matriarch': { chance: 1, min: 104, max: 247 },
  'avalanche_golem': { chance: 1, min: 138, max: 325 },
  'skeletal_warrior': { chance: 1, min: 30, max: 75 },
  'skeletal_mage': { chance: 1, min: 32, max: 80 },
  'tomb_scarab': { chance: 1, min: 30, max: 75 },
  'cursed_archaeologist': { chance: 1, min: 150, max: 360 },
  'kobold_miner': { chance: 0.7, min: 15, max: 38 },
  'kobold_shaman': { chance: 0.7, min: 17, max: 43 },
  'plague_rat': { chance: 0.6, min: 8, max: 20 },
  'dire_wolf': { chance: 0.6, min: 12, max: 30 },
  'owlbear': { chance: 0.8, min: 23, max: 58 },
  'basilisk': { chance: 1, min: 33, max: 83 },
  'kobold_worker': { chance: 0.4, min: 2, max: 5 },
  'kobold_tunneler': { chance: 0.5, min: 5, max: 13 },
  'brigand_thug': { chance: 0.6, min: 8, max: 20 },
  'duchess': { chance: 0.7, min: 14, max: 35 },
  'rimecrest_troll': { chance: 0.5, min: 3, max: 8 },
  'wendigo': { chance: 0.6, min: 8, max: 20 },
  'mindless_zombie': { chance: 0.4, min: 2, max: 5 },
  'ember_vigil_zealot': { chance: 0.6, min: 12, max: 30 },
  'sandstinger': { chance: 0.8, min: 20, max: 50 },
  'voodoo_troll': { chance: 0.6, min: 8, max: 20 },
  'brigand_raider': { chance: 0.8, min: 18, max: 45 },
  'scarecrow_golem': { chance: 0.8, min: 21, max: 53 },
  'stripe_runner': { chance: 0.7, min: 17, max: 43 },
  'centaur_scout': { chance: 0.8, min: 23, max: 58 },
  'thornpaw_pathfinder': { chance: 0.9, min: 27, max: 68 },
  'amberbark_treant': { chance: 1, min: 30, max: 75 },
  'naga_siren': { chance: 0.8, min: 23, max: 58 },
  'brigand_smuggler': { chance: 0.8, min: 23, max: 58 },
  'brigand_lieutenant': { chance: 0.9, min: 26, max: 65 },
  'deepglow_ooze': { chance: 0.9, min: 24, max: 60 },
  'rabbit': { chance: 0.4, min: 2, max: 5 },
  'rat': { chance: 0.4, min: 2, max: 5 },
  'deer': { chance: 0.4, min: 2, max: 5 },
  'captain_morrow_vane': { chance: 1, min: 32, max: 80 },
  'gilling_coastrunner': { chance: 0.6, min: 9, max: 23 },
  'gilling_bogchief': { chance: 1, min: 90, max: 210 },
  'scarecrow_warden': { chance: 0.9, min: 24, max: 60 },
  'moonhowler_lurker': { chance: 0.8, min: 21, max: 53 },
  'clodkin_stonecutter': { chance: 0.5, min: 6, max: 15 },
  'tuskmire_raider': { chance: 0.7, min: 15, max: 38 },
  'tuskmire_warchief': { chance: 1, min: 60, max: 140 },
  'gearwright_logger': { chance: 1, min: 30, max: 75 },
  'longleg_strider': { chance: 0.5, min: 5, max: 13 },
  'canopy_weaver': { chance: 0.5, min: 5, max: 13 },
  'murkwater_snapjaw': { chance: 1, min: 33, max: 83 },
  'stormbreak_wyvern': { chance: 0.9, min: 27, max: 68 },
  'tuskmire_grunda': { chance: 1, min: 23, max: 54 },
  'gilling_glimmergill': { chance: 1, min: 38, max: 90 },
  'sandstinger_sunback': { chance: 1, min: 50, max: 120 },
  'stormbreak_galeclaw': { chance: 1, min: 43, max: 102 },
  'rimecrest_brakka': { chance: 1, min: 58, max: 138 },
  'moonhowler_tobin': { chance: 1, min: 40, max: 96 },
  'ember_vigil_aldous': { chance: 1, min: 53, max: 126 },
  'thornpaw_mossclaw': { chance: 1, min: 48, max: 114 },
  'clodkin_chertjaw': { chance: 1, min: 43, max: 102 },
  'fire_drake_ashkettle': { chance: 1, min: 48, max: 114 },
  'centaur_sorrel': { chance: 1, min: 65, max: 156 },
};
